namespace app.informacoes {
    "use strict";
    
    import IStateProvider = angular.ui.IStateProvider;

    /** @ngInject * */
    function config($stateProvider: IStateProvider) {
        $stateProvider.state("app.informacoes", {
            abstract: true,
            url: "/informacoes",
            parent: "app.autenticado"
        });
    }

    /** @ngInject */
    function run(stfBreadcrumbsService: app.support.StfBreadcrumbsService) {
        stfBreadcrumbsService.registerPath({
            id: "informacoes",
            translation: "Informações",
            uisref: "app.informacoes"
        });
    }

    angular
        .module("app.informacoes", ["app.autenticado", "app.support"])
        .config(config)
        .run(run);
}